<template>
  <div>
    <hhead></hhead>
    <!-- <nnav></nnav> -->

    <div
      class="help_box"
      :style="{
        height: MHeight,
      }"
    >
      <div class="help_left" style="position: relative;">
        <!-- <div class="block" style="position: absolute;left: 0;top: 80px;">
          <el-slider :step="10" show-stops  v-model="value" vertical height="1200px">
          </el-slider>
        </div> -->
        <div
          style="padding-left: 10px;font-size: 20px;color: #5B85FF;font-weight: 500;cursor: pointer;margin-bottom: 10px;"
          @click="jump2"
        >
          {{ title }}
        </div>
        <a
          v-for="(item, index) in res.data"
          :key="index"
          style="cursor: pointer;display: block;box-sizing: border-box;padding-left: 30px;color: #181E2D;margin-bottom: 15px;font-size: 18px;"
        >
          <div
            :class="{ active_color: active == item.name }"
            @click="jump(item.md, item.name, item)"
            style="font-size: 16px;padding: 3px 0 8px;position: relative;"
          >
            <i
              v-show="!item.deleted && item.childs.length"
              class="el-icon-caret-bottom"
              style="position: absolute;left: -15px;top: 6px;"
            ></i>
            <i
              v-show="item.deleted && item.childs.length"
              class="el-icon-caret-top"
              style="position: absolute;left: -17px;top: 6px;"
            ></i>
            {{ item.name }}
          </div>
          <div
            v-show="!item.deleted"
            :class="{ active_color: active == e.name }"
            style="font-size: 14px;padding: 3px 22px;position: relative;"
            v-for="(e, i) in item.childs"
            :key="i"
            @click="jump(e.md, e.name, e)"
          >
            <span
              style="position: absolute;display: block;width: 10px;height: 25px;border-bottom: 1px dashed #CED5E4;border-left: 1px  dashed #CED5E4;left: 7px;top: -12px;"
            ></span>
            {{ e.name }}
          </div>
        </a>
      </div>

      <div class="help_right">
        <div style="height: 30px;"></div>
        <div
          :id="title"
          style="font-size: 24px;font-weight: 500;margin-bottom: 40px;color:#5B85FF"
        >
          {{ title }}
        </div>
        <div v-for="(item, index) in res.data" :key="index">
          <h3
            style="font-size: 18px;font-weight: 500;margin-bottom: 20px;color:#5B85FF;display: flex;margin-top: 20px;"
            :id="'a' + item.id"
          >
            <p
              style="width: 3px;height: 16px;background-color: #5B85FF;margin-top: 5px;margin-right: 10px;"
            ></p>
            {{ item.name }}
          </h3>
          <div v-html="item.text"></div>
          <div v-for="(e, i) in item.childs" :key="i">
            <h2
              :id="'a' + e.id"
              style="font-size: 16px;font-weight: 500;margin: 20px 0;color:#5B85FF"
            >
              {{ e.name }}
            </h2>
            <div v-html="e.text"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hhead from '../../components/header/index';
import nnav from '../../components/nav/index';
import './style.css';
import $ from 'jquery';
export default {
  components: { hhead, nnav },
  data() {
    return {
      MHeight: document.documentElement.clientHeight - 54 + 'px',
      res: [],
      tr: true,
      childs: [],
      type: '',
      active: '',
      title: '',
      value: 0,
    };
  },
  mounted() {
    this.type = this.$route.query.type;
    this.$axios
      .post('/api/helps', { type: this.type })
      .then((res) => {
        console.log(res);
        res.data.data.forEach((item) => {
          item.md = '#a' + item.id;

          if (item.childs) {
            item.childs.forEach((e) => {
              this.childs.push(e.id);
              e.md = '#a' + e.id;
            });
          }
        });

        this.res = res.data;

        var that = this;
        this.$nextTick(() => {
          //带参数进网页
          setTimeout(() => {
            this.res.data.forEach((item) => {
              console.log(item.name, 666);
              if (this.$route.query.name == item.name) {
                if (this.$route.query.name == item.name) {
                  this.jump(item.md, item.name, item);
                }
              }

              if (item.childs) {
                item.childs.forEach((e) => {
                  this.childs.push(e.id);
                  e.md = '#a' + e.id;

                  if (this.$route.query.name == e.name) {
                    this.jump(e.md, e.name, e);
                  }
                });
              }
            });
          }, 0);
        });
      })

      .catch((err) => {
        // console.log(err);
      });
  },
  methods: {
    jump(id, name, e) {
      console.log(id);
      e.deleted = !e.deleted;
      document.querySelector(id).scrollIntoView(true);
      this.active = name;
      //querySelector可以获取dom元素，括号内为css属性选择器；
      // console.log(e);
    },
    jump1(id) {
      document.querySelector(id).scrollIntoView(true);
    },
    jump2() {
      var title = '#' + this.title;
      document.querySelector(title).scrollIntoView(true);
      // console.log(title);
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
  },
  watch: {
    type() {
      if (this.type == '4') {
        this.title = '交易端手册';
      }
      if (this.type == '5') {
        this.title = '多账户交易端手册';
      }
    },
  },
};

// setTimeout(() => {
//   var aImgs = document.querySelectorAll('p img');
//   for (var i = 0; i < aImgs.length; i++) {
//     aImgs[i].src = 'https://yun.jeesit.com' + aImgs[i].getAttribute('src');
//   }
// }, 100);
function imgSrc() {
  var aImgs = document.querySelectorAll('p img');
  for (var i = 0; i < aImgs.length; i++) {
    aImgs[i].src =
      'https://yunsrvwebapi.jeesit.com' + aImgs[i].getAttribute('src');
  }
}
window.onload = function() {
  setTimeout(function() {
    imgSrc();
  }, 500);
};
</script>
<style>
.el-menu {
  border-right: 0 !important;
}
.el-submenu .el-menu-item {
  height: 28px;
  line-height: 28px;
}
.el-menu-item,
.el-submenu__title {
  height: 28px;
  line-height: 28px;
}
.el-menu-item-group__title {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/help/index.vue